/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMLoginLessMethodEvent } from '@/data/events/handlers/gtm/LoginLessMethod';
import { GTMLoginLessMethodPayload } from '@/data/types/GTM';

type LoginLessMethodDelegatorProps = {
	gtm?: GTMLoginLessMethodPayload;
};

export const loginLessMethodDelegator = async (payload: LoginLessMethodDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMLoginLessMethodEvent(gtm);
	}
};
